import { colors } from '../sharedStyles';

export default function Presentation({ scrollToSection }) {
    return (
        <section id="about" style={{ paddingTop: '8rem', paddingBottom: '8rem', backgroundColor: colors.white }}>
            <div style={{ maxWidth: '64rem', margin: '0 auto', padding: '0 1.5rem' }}>
                <h2 className="fade-in-up" style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', fontWeight: 800, marginBottom: '3rem', textAlign: 'center', color: colors.primary, textTransform: 'uppercase', letterSpacing: '2px' }}>
                    ANTICIPER, C'EST GARDER LE CHOIX.
                </h2>

                <div className="fade-in-up" style={{ marginBottom: '4rem' }}>
                    <p style={{ fontSize: '1.25rem', fontWeight: 600, color: colors.text, marginBottom: '0.5rem', textAlign: 'center' }}>
                        Votre entreprise progresse.
                    </p>
                    <p style={{ fontSize: '1.25rem', fontWeight: 400, color: colors.textLight, textAlign: 'center' }}>
                        Votre pilotage financier est-il prêt à suivre ?
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem', alignItems: 'stretch' }}>

                    {/* Problem */}
                    <div className="fade-in-up" style={{ height: '100%' }}>
                        <div style={{ height: '100%', padding: '2rem', borderRadius: '8px', backgroundColor: colors.white, border: `1px solid ${colors.lightGray}`, boxShadow: '0 4px 6px rgba(0,0,0,0.02)' }}>
                            <h3 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1.5rem', color: colors.primary, display: 'inline-block' }}>
                                Dans de nombreuses entreprises :
                            </h3>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                {[
                                    "Les décisions sont prises au feeling",
                                    "La trésorerie crée une tension permanente",
                                    "Les dirigeants passent trop de temps sur les chiffres",
                                    "Les indicateurs existent sans réellement piloter l'action"
                                ].map((item, index) => (
                                    <li key={index} style={{ fontSize: '1.1rem', color: colors.textLight, display: 'flex', alignItems: 'start', gap: '0.75rem' }}>
                                        <span style={{ color: colors.secondary, fontSize: '1.2rem', lineHeight: 1 }}>•</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Consequence */}
                    <div className="fade-in-up" style={{ height: '100%' }}>
                        <div style={{ height: '100%', backgroundColor: '#f8f9fa', padding: '2rem', borderRadius: '8px', borderLeft: `4px solid ${colors.secondary}`, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <p style={{ fontSize: '1.1rem', lineHeight: 1.6, color: colors.text, margin: 0 }}>
                                <b>Conséquence :</b> Lorsque la croissance n'est pas accompagnée d'une structuration financière adaptée, la trésorerie devient une contrainte, les décisions se tendent et les marges se réduisent.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Approach */}
                <div className="fade-in-up" style={{ maxWidth: '48rem', margin: '0 auto 4rem auto', textAlign: 'center', backgroundColor: colors.lightBlueBg, padding: '2rem', borderRadius: '12px' }}>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: colors.primary }}>
                        Mon approche : structurer avant de subir.
                    </h3>
                    <p style={{ fontSize: '1.2rem', lineHeight: 1.6, color: colors.text }}>
                        Mettre en place une organisation financière claire permet de conserver liberté, maîtrise et capacité d'action, même en phase d'accélération.
                    </p>
                </div>

                <div className="fade-in-up" style={{ textAlign: 'center' }}>
                    <button
                        onClick={() => scrollToSection('services')}
                        style={{
                            backgroundColor: 'transparent',
                            color: colors.primary,
                            padding: '1rem 2rem',
                            borderRadius: '50px',
                            fontWeight: 700,
                            fontSize: '1rem',
                            border: `2px solid ${colors.primary}`,
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => { e.target.style.backgroundColor = colors.primary; e.target.style.color = colors.white; }}
                        onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = colors.primary; }}
                    >
                        Voir comment je travaille
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>

            </div>
        </section>
    );
}
